var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-lg-12"},[_c('div',[_c('ticket-stats',{attrs:{"dateTime":_vm.dateTime}})],1)])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }